import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../app/store';
import { fetchCount } from '../api/counterAPI';
import { postRequest } from '../app/postRequest.service';
import { LoginRequest, LoginResponse } from '../interfaces/login';
import { loginApi } from '../api/loginAPI';
import { activeClaimsApi } from '../api/homeAPI';
import { ActiveClaimsResponse } from '../interfaces/claim.interface';

export interface ActiveClaimsState {
  value: ActiveClaimsResponse | null;
  status: 'idle' | 'loading' | 'failed';
}

const initialState: ActiveClaimsState = {
  value: null,
  status: 'idle',
};

export const activeClaimsAsync = createAsyncThunk(
  'activeClaims/activeClaimsAsync',
  async () => {
    const response = await activeClaimsApi()
    return response.data;
  }
);

export const activeClaimsSlice = createSlice({
  name: 'activeClaims',
  initialState,
  
  reducers: {
    // increment: (state) => { 
    //   state.value += 1;
    // },
    // decrement: (state) => {
    //   state.value -= 1;
    // },
    
    // incrementByAmount: (state, action: PayloadAction<number>) => {
    //   state.value += action.payload;
    // },
  },
  
  
  extraReducers: (builder) => {
    builder
      .addCase(activeClaimsAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(activeClaimsAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.value = action.payload;
      })
      .addCase(activeClaimsAsync.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export const { } = activeClaimsSlice.actions;
export const getActiveClaims = (state: RootState) => state.activeClaims.value;
export const getActiveClaimsLoading = (state: RootState) => state.activeClaims.status === 'loading';

export default activeClaimsSlice.reducer;
